import { render, staticRenderFns } from "./problem-render-header.vue?vue&type=template&id=3c8e355f&"
import script from "./problem-render-header.component.ts?vue&type=script&lang=js&"
export * from "./problem-render-header.component.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/3/gateway/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8e355f')) {
      api.createRecord('3c8e355f', component.options)
    } else {
      api.reload('3c8e355f', component.options)
    }
    module.hot.accept("./problem-render-header.vue?vue&type=template&id=3c8e355f&", function () {
      api.rerender('3c8e355f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/problem-renderer/problem-render-header.vue"
export default component.exports